import React, { useState, useEffect } from "react";
import { Button, Tooltip, Autocomplete, TextField } from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CustomModal from "../../components/CustomModel";
import FormInput from "../../components/GeneralComponents/FormInput";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";
import { formatNumber, show_proper_words } from "../../utils/constant";
import {
  List_Account_Topup_For_Admin,
  Update_Acount_Top_Up_Status,
} from "../../DAL/Listing/ActionsHistoy";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import moment from "moment";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";

const TopUpFunds = ({ dashboard }) => {
  const { setnavbarTitle, socket } = useAdminContext();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [rowDataID, setRowDataID] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [rowData, setRowData] = useState({});
  const [topUpFee, setTopUpFee] = useState(null);
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [modelState, setModelState] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [Data, setData] = useState({
    address: "",
  });
  const [employee, setEmployee] = useState(null);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const percentageOptions = [...Array(21)].map((_, index) => {
    const value = (index * 0.5).toFixed(1); // starts from 0.0
    return {
      value,
      _id: index,
    };
  });

  /**
   * handleGetDetailUser - Fetches and formats employee details based on a search query.
   *
   * This function sends a request to retrieve employee data, formats the response to extract employee IDs, names, and emails,
   * and updates the state with the formatted employee list for further use.
   */
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  /**
   * handleCloseModel - Resets the modal state and clears form data when the modal is closed.
   *
   * This function resets various state variables related to the modal, including the form data, selected employee, and other flags.
   * It ensures that the modal is closed and any user selections are cleared.
   */
  const handleCloseModel = () => {
    setRowDataID("");
    setData({
      address: "",
    });
    setTopUpFee(null);
    setEmployee(null);
    setRowData(null);
    setModelState(false);
    setIsCancel(false);
  };

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  /**
   * updateTopUpStatus - Handles the form submission to update the top-up status for an account.
   *
   * This function sends the top-up status update request based on the provided employee ID, address, status, and fee percentage.
   * It also emits a socket event to notify other clients and updates the account list after the operation is completed.
   */
  const updateTopUpStatus = async (e) => {
    e.preventDefault();
    const formData = {
      user_id: employee?.id,
      message: Data?.address,
      status: isCancel ? "rejected" : "approved",
      fee_percentage: topUpFee?.value,
    };
    setLoadingButton(true);
    const response = await Update_Acount_Top_Up_Status(formData, rowDataID);
    if (response.code === 200) {
      socket.emit("account_topup_event", {
        notification: response.notification,
      });
      setData({
        address: "",
      });
      setEmployee(null);
      GetAppealAccountList();
      handleCloseModel();
      setLoadingButton(false);
    } else {
      setLoadingButton(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * User_Table_Head - Defines the table columns and their respective rendering logic for the user table.
   *
   * Each column is associated with a label, an optional rendering function for custom data formatting,
   * and actions such as viewing details or applying specific styles (e.g., showing a status chip or formatting amounts).
   */
  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              style={{
                fill: "#fff",
                marginRight: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setRowData(row);
                setRowDataID(row._id);
                setModelState(true);
              }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "c",
      label: "Created At",
      renderData: (row) => (
        <div>{moment(row?.date_time).format("DD MMM YY hh:mm A")}</div>
      ),
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            setRowDataID(row._id);
            setRowData(row);
            setModelState(true);
          }}
        >
          <div>
            {show_proper_words(
              row?.user_info?.first_name + " " + row?.user_info?.last_name
            ) || "_ _"}
          </div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row?.user_info?.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "accountName",
      label: "Account",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            setRowData(row);
            setRowDataID(row._id);
            setModelState(true);
          }}
        >
          <div>{row?.account_name || "_ _"}</div> {/* Business Entity Above */}
          <div className="text-muted">{row?.email || "_ _"}</div>{" "}
          {/* Business Email Underneath */}
        </div>
      ),
    },
    {
      id: "amount",
      label: "Top Up Amount",
      renderData: (row) => (
        <div>
          $
          {Number(row?.topup_amount) > 0
            ? formatNumber(row?.topup_amount)
            : "_" || "_ _"}
        </div>
      ),
    },
    {
      id: "topup_amount",
      label: "Amount Sent",
      renderData: (row) => (
        <span>
          {Number(row.amount) > 0
            ? "$" + formatNumber(row.amount)
            : "_" || "$0"}
        </span>
      ),
    },
    {
      id: "amount",
      label: "Ads Spend Fee",
      renderData: (row) => (
        <div>
          {Number(row?.fee_charged) > 0
            ? "$" + formatNumber(row?.fee_charged)
            : "_" || "_ _"}
        </div>
      ),
    },
    {
      id: "topup_amount",
      label: "Fee Percentage",
      renderData: (row) => (
        <span>
          {Number(row?.fee_percentage)
            ? formatNumber(row?.fee_percentage) + "%"
            : "_" || "0%"}
        </span>
      ),
    },
    {
      id: "type",
      label: "Account Type",
      renderData: (row) => (
        <span className=" capitalized">{row.type || "_ _"}</span>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip status={row.status} type="activeInactive" />
      ),
    },
  ];

  /**
   * GetAppealAccountList - Fetches the list of account top-ups for the admin.
   *
   * This function retrieves data using the List_Account_Topup_For_Admin API,
   * then updates the state variables for the user list, total count, and total pages.
   * It also manages loading state and handles error scenarios with notifications.
   */
  const GetAppealAccountList = async () => {
    setLoading(true);
    const formData = {};
    const response = await List_Account_Topup_For_Admin(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { list_topups = [], total_count, total_pages } = response;
      setUserList(list_topups);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar("Failed to fetch data", { variant: "error" });
    }
  };

  useEffect(() => {
    if (!dashboard) {
      setnavbarTitle("Top Up Funds");
    }
    GetAppealAccountList(page, rowsPerPage);
  }, [page, rowsPerPage, location.state?.refresh]);

  useEffect(() => {
    handleGetDetailUser();
  }, []);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="mt-3">
      <CustomTable
        data={userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        is_hide={true}
      />
      <CustomModal
        crossButton={true}
        // CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <form onSubmit={updateTopUpStatus}>
            {isCancel ? (
              <div className="mt-4">
                <FormInput
                  label="Reject Message"
                  name="address"
                  type="text"
                  multline={true}
                  value={Data.address}
                  onChange={(e) =>
                    setData({ ...Data, address: e.target.value })
                  }
                />
              </div>
            ) : (
              <>
                <h5>Funds Details</h5>
                <div className="d-flex justify-content-between align-center mt-2">
                  <p className="mb-0">Created At</p>
                  <p className="mb-0">Account</p>
                </div>
                <div className="d-flex justify-content-between align-center mt-1">
                  <p className="mb-0 text-muted">
                    {moment(rowData?.date_time).format("DD MMM YY hh:mm A")}
                  </p>
                  <p className="mb-0 text-muted">{rowData?.account_name}</p>
                </div>
                <div className="d-flex justify-content-between align-center mt-2">
                  <p className="mb-0">Business Email</p>
                  <p className="mb-0">Top Up Amount</p>
                </div>
                <div className="d-flex justify-content-between align-center mt-1">
                  <p
                    className="mb-0 text-muted"
                    style={{
                      overflowWrap: "anywhere",
                    }}
                  >
                    {rowData?.email}
                  </p>
                  <p className="mb-0 text-muted">{rowData?.topup_amount}</p>
                </div>
                <hr />
                {rowData?.status !== "approved" && (
                  <div className="row">
                    <div className="col-6 mt-3">
                      <Autocomplete
                        value={topUpFee}
                        onChange={(event, newValue) => setTopUpFee(newValue)}
                        options={percentageOptions}
                        getOptionLabel={(option) =>
                          option?.value ? `${option.value}%` : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Top Up Fee"
                            variant="outlined"
                            fullWidth
                            required
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props}>{option.value}%</li>
                        )}
                      />
                    </div>

                    <div className="col-6 mt-3 d-flex align-items-center">
                      {topUpFee && rowData?.topup_amount ? (
                        <div>
                          <strong>Amount after Top Up Fee:</strong> $
                          {(
                            rowData.topup_amount -
                            (rowData.topup_amount *
                              parseFloat(topUpFee.value)) /
                              100
                          ).toFixed(2)}
                        </div>
                      ) : (
                        <div className="text-muted">
                          Select a fee to calculate amount
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="my-3">
                  <SingleSelectAutocomplete
                    inputLabel="Approve or Reject By"
                    selectedOption={employee}
                    setSelectedOption={setEmployee}
                    optionsList={employeeArray}
                    required={true}
                    name="name"
                    size="medium"
                  />
                </div>
              </>
            )}
            <div className="col-12 text-end mt-3">
              {!isCancel ? (
                <>
                  {rowData?.status !== "rejected" && (
                    <Button
                      variant="contained"
                      disabled={!employee || loadingButton}
                      onClick={() => {
                        setIsCancel(true);
                      }}
                    >
                      Reject
                    </Button>
                  )}
                </>
              ) : (
                <Button
                  variant="contained"
                  disabled={loadingButton}
                  s
                  onClick={() => {
                    setIsCancel(false);
                  }}
                >
                  Back
                </Button>
              )}

              {/* Only show the Approve/Reject button when needed */}
              {(rowData?.status !== "approved" || isCancel) && (
                <Button
                  variant="contained"
                  className="ms-3"
                  disabled={!employee || loadingButton}
                  type="submit"
                >
                  {loadingButton
                    ? "Please Wait..."
                    : isCancel
                    ? "Reject"
                    : "Approve"}
                </Button>
              )}
            </div>
          </form>
        }
      />
    </div>
  );
};

export default TopUpFunds;
